import { ResourceState as ResourceStateEnum } from '@mews-commander/data-access';
import { enumify, Enumify, EnumValue } from '@mews/enumify';

function ResourceState() {}

enumify<ResourceStateEnum, number>(ResourceState, 'ResourceState', {
    Dirty: 0,
    Clean: 1,
    Inspected: 2,
    OutOfService: 3,
    OutOfOrder: 4,
});

export type ResourceStateValue = EnumValue<ResourceStateEnum, number>;

export default ResourceState as unknown as Enumify<ResourceStateEnum, number>;
